import { JobTicketStore } from 'jobs/tickets/JobTicketStore'
import Job from 'jobs/Job'
import { makeObservable, computed } from 'mobx'

/**
 * View model for the job's tickets.
 */
export class JobTicketsViewModel {
  constructor(
    private readonly job: Job,
    private readonly jobTicketStore: JobTicketStore,
  ) {
    makeObservable(this, {
      latestTicket: computed,
    })
  }

  /**
   * Gets the latest ticket for the job, if any.
   */
  get latestTicket() {
    return this.jobTicketStore.getLatestTicketForJob(this.job.id)
  }

  /**
   * Activate the view model.
   */
  async activate() {
    await this.fetch()
  }

  /**
   * Fetches the ticket information.
   */
  private async fetch() {
    try {
      await this.jobTicketStore.fetchLatestOpenTicketsForJobs([this.job.id])
    } catch (err: unknown) {
      console.error(
        'An error occurred while loading the latest ticket for job',
        this.job.id,
        err,
      )
    }
  }

  /**
   * Deactivate the view model.
   */
  deactivate() {
    //
  }
}
